export default __webpack_public_path__ + "static/media/img-ovato-brand-new.10364a5c.jpg";